import Routers from "../constants/routers";

const VIEWPORT_LIST_PATHS = new Set<string>([
  Routers.Affiliates,
  Routers.Items,
  Routers.DocumentTemplates,
  Routers.CancelContracts,
  Routers.Notices,
  Routers.ContractRenewals,
  Routers.VariableCostApplications,
  Routers.InclusiveContractApplicationManagement,
  Routers.SubrogationPayment,
  Routers.Invoices,
  Routers.Applications,
  Routers.AffiliateApplications,
  Routers.NotificationDeliveries,
  Routers.Delinquents,
  Routers.VariableCostRegistration,
  Routers.Staff
]);

export const isAdminViewportList = (pathname: string): boolean => VIEWPORT_LIST_PATHS.has(pathname.replace(/\/$/, ""));
